module.exports = __webpack_public_path__ + "static/media/noti-bg1.48d4f003.jpg";